import * as THREE from 'three'
import EdgeMesh from 'types/edge-mesh'

export const edgesMeshToGeometry = (
  edgesMesh: EdgeMesh[],
): THREE.BufferGeometry => {
  const positions = []
  const indicies = []
  const geometry = new THREE.BufferGeometry()

  edgesMesh.forEach((e) => {
    const startIdx = positions.length / 3
    for (let i = 0; i < e.points.length; i++) {
      if (i < e.points.length - 1) {
        indicies.push(startIdx + i)
        indicies.push(startIdx + i + 1)
      }

      positions.push(e.points[i][0])
      positions.push(e.points[i][1])
      positions.push(e.points[i][2])
    }
  })

  geometry.setAttribute(
    'position',
    new THREE.Float32BufferAttribute(positions, 3),
  )

  geometry.setIndex(indicies)
  return geometry
}
